/* ll-home.js · Llama Land homepage (Option C), owner: homepage builder.
   Ported from the round's src/app.js (C variant) + src/why-c.js. Loaded deferred after stage 0's motion runtime
   (ll-gsap, ScrollTrigger, CustomEase, MotionPathPlugin, ll-motion-boot = window.LNMotion).
   Two layers:
     1. common UI, both modes, with or without the motion runtime: dialogs, lab tabs, Show More Reviews, the phone
        review row, video previews + Pause chip + sound dialog, the bundle offer Add to Cart, the floating-fruit guard.
     2. motion, only when LNMotion says motion (reduced motion, ?motion=static, a hidden boot or a stall = the CSS still):
        hero intro + parallax (the jar is never hidden: LCP), honor rays, entrances, bands, the ingredients pin
        (pure function of scroll), the sunset scrub, floating fruit, previews start near.
   Dropped from the prototype: riso kit, ScrollTo, split jar, Club, gutter trail, mock cart/offer, fly-to-bag, toast,
   hero Earnest pop-up, the hidden-tab auto-reload. Sections re-init on shopify:section:load (theme editor). */
(function () {
  'use strict';
  var D = document, W = window;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };
  var clamp = function (v, a, b) { a = a == null ? 0 : a; b = b == null ? 1 : b; return Math.min(b, Math.max(a, v)); };
  var seg = function (p, a, b) { return clamp((p - a) / (b - a)); };
  var hdrH = function () {
    var h = $('.shopify-section.ll-sec--header') || $('[data-ll-header]');
    if (h) return h.offsetHeight;
    var v = parseFloat(getComputedStyle(D.documentElement).getPropertyValue('--ll-hdr'));
    return isNaN(v) ? 0 : v;
  };
  var money = function (c) { return '$' + (c / 100).toFixed(2); };

  /* =============================================================== 1. common UI */
  function common() {
    /* ---------- dialogs (proof popups, founders' story, kit, video, label) ---------- */
    function loadMedia(dlg) { $$('img[data-src]', dlg).forEach(function (im) { im.setAttribute('src', im.getAttribute('data-src')); im.removeAttribute('data-src'); }); }
    function openDialog(id, opener) {
      var dlg = D.getElementById(id);
      if (!dlg || typeof dlg.showModal !== 'function' || dlg.open) return;
      $$('dialog.ll-c-dlog[open]').forEach(function (o) { if (o !== dlg) o.close(); });
      loadMedia(dlg);
      dlg.__opener = opener || null;
      dlg.showModal();
      if (W.LNMotion && W.LNMotion.motion && W.gsap) W.gsap.fromTo(dlg, { y: 24, opacity: 0 }, { y: 0, opacity: 1, duration: .24, ease: 'power2.out', clearProps: 'transform,opacity' });
    }
    W.LLHome = W.LLHome || {}; W.LLHome.openDialog = openDialog;
    $$('[data-dialog]').forEach(function (b) {
      if (b.__llDlg) return; b.__llDlg = 1;
      b.addEventListener('click', function (e) { e.preventDefault(); openDialog(b.getAttribute('data-dialog'), b); });
    });
    $$('dialog.ll-c-dlog').forEach(function (dlg) {
      if (dlg.__llDlg) return; dlg.__llDlg = 1;
      $$('.ll-c-dlog-x, .ll-c-dlog-go', dlg).forEach(function (x) { x.addEventListener('click', function () { dlg.close(); }); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      dlg.addEventListener('close', function () {
        $$('video', dlg).forEach(function (v) { try { v.pause(); } catch (err) {} });
        var o = dlg.__opener; if (o && D.contains(o) && !$('dialog[open]')) { try { o.focus({ preventScroll: true }); } catch (err) {} }
      });
    });

    /* ---------- lab report tabs + serving select ---------- */
    var tabs = $$('.ll-c-ev-tabs [role=tab]');
    function selectTab(t) { tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1; var pn = D.getElementById(x.getAttribute('aria-controls')); if (pn) pn.hidden = !on; }); }
    tabs.forEach(function (t, i) {
      if (t.__ll) return; t.__ll = 1;
      t.addEventListener('click', function () { selectTab(t); });
      t.addEventListener('keydown', function (e) { var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!k) return; e.preventDefault(); var n = tabs[(i + k + tabs.length) % tabs.length]; selectTab(n); n.focus(); });
    });
    var dose = $('[data-evidence-dose]');
    if (dose && !dose.__ll) { dose.__ll = 1; dose.addEventListener('change', function () { $$('[data-evidence-serving]').forEach(function (d) { d.hidden = d.getAttribute('data-evidence-serving') !== dose.value; }); }); }

    /* ---------- Show More Reviews (opens the extra postcards in place) ---------- */
    var moreBtn = $('#moreReviews');
    if (moreBtn && !moreBtn.__ll) {
      moreBtn.__ll = 1;
      moreBtn.addEventListener('click', function () {
        var extra = $$('.ll-c-rv-extra');
        extra.forEach(function (f) { f.hidden = false; });
        moreBtn.setAttribute('aria-expanded', 'true');
        moreBtn.parentNode.hidden = true;
        if (extra[0]) { extra[0].setAttribute('tabindex', '-1'); extra[0].focus({ preventScroll: true }); }
        if (W.LNMotion && W.LNMotion.motion && W.gsap) W.gsap.from(extra, { y: 14, duration: .45, ease: 'power2.out', stagger: .06, clearProps: 'transform' });
        if (W.ScrollTrigger) setTimeout(function () { W.ScrollTrigger.refresh(); }, 60);
      });
    }
    reviewRow();

    /* ---------- customer videos: muted previews behind the Play/Pause chip, tap = sound dialog ---------- */
    var previews = $$('.ll-c-vid-prev'), pv = $('#previewToggle'), on = false;
    function loadPreviews() { previews.forEach(function (v) { if (!v.getAttribute('src') && v.getAttribute('data-src')) v.setAttribute('src', v.getAttribute('data-src')); }); }
    function sync() {
      previews.forEach(function (v) {
        var r = v.getBoundingClientRect(), vis = r.bottom > 0 && r.top < W.innerHeight && r.right > 0 && r.left < W.innerWidth;
        var frac = vis ? (Math.min(r.bottom, W.innerHeight) - Math.max(r.top, 0)) / Math.max(1, r.height) : 0;
        if (on && frac > .6 && !D.hidden) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else if (!v.paused) v.pause();
      });
    }
    function setPreviews(v) {
      on = v; if (!pv) return;
      pv.setAttribute('aria-pressed', String(v));
      var sp = $('span', pv); if (sp) sp.textContent = v ? pv.getAttribute('data-pause') : pv.getAttribute('data-play');
      var u = $('use', pv); if (u) u.setAttribute('href', u.getAttribute('href').replace(/#i-(play|pause)$/, v ? '#i-pause' : '#i-play'));
      if (v) loadPreviews();
      sync();
    }
    W.LLHome.setPreviews = setPreviews;
    if (pv && !pv.__ll) {
      pv.__ll = 1;
      pv.addEventListener('click', function () { setPreviews(!on); });
      var t = 0; W.addEventListener('scroll', function () { if (!on) return; clearTimeout(t); t = setTimeout(sync, 450); }, { passive: true });
      D.addEventListener('visibilitychange', sync);
    }
    var player = $('#customer-video-player'), vt = $('#customer-video-title');
    $$('.ll-c-vid-open').forEach(function (b) {
      if (b.__ll) return; b.__ll = 1;
      b.addEventListener('click', function () {
        if (!player) return;
        if (b.getAttribute('data-poster')) player.setAttribute('poster', b.getAttribute('data-poster'));
        player.setAttribute('src', b.getAttribute('data-video')); player.muted = false;
        if (vt) vt.textContent = b.getAttribute('data-quote') || vt.getAttribute('data-default') || vt.textContent;
        openDialog('customer-video-dialog', b);
        var p = player.play(); if (p && p.catch) p.catch(function () {});
      });
    });

    heroStack();
    shopTabs();
    bundleOffer();
    fruitGuard();
  }

  /* ---------- shop tabs (Kids / Adults / Bundle & Save): ARIA tabs, roving tabindex, arrows / Home / End move and select.
     Both modes; motion only adds the pill slide and a short rise of the new panel (transform and opacity). ---------- */
  function shopTabs() {
    var tl = $('[data-ll-tabs]'); if (!tl || tl.__ll) return; tl.__ll = 1;
    var tabs = $$('[role="tab"]', tl), thumb = $('.ll-c-st-thumb', tl), quiet = false;
    var cur = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
    function moving() { return !quiet && W.LNMotion && W.LNMotion.motion && W.gsap && D.documentElement.classList.contains('motion'); }
    function select(t, focus) {
      if (t === cur) { if (focus) t.focus(); return; }
      var from = cur, oldPanel = D.getElementById(from.getAttribute('aria-controls')), panel = D.getElementById(t.getAttribute('aria-controls'));
      tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1; });
      if (oldPanel) oldPanel.hidden = true; if (panel) panel.hidden = false; cur = t;
      if (focus) t.focus();
      if (tl.scrollWidth > tl.clientWidth) tl.scrollLeft = Math.max(0, t.offsetLeft - (tl.clientWidth - t.offsetWidth) / 2);
      if (W.ScrollTrigger) setTimeout(function () { W.ScrollTrigger.refresh(); }, 60);   /* the page below changed height */
      if (!moving() || !thumb) return;
      var gsap = W.gsap, a = from.getBoundingClientRect(), b = t.getBoundingClientRect(), base = tl.getBoundingClientRect();
      tl.classList.add('is-sliding');
      gsap.killTweensOf(thumb);
      gsap.fromTo(thumb, { x: a.left - base.left + tl.scrollLeft, width: a.width, opacity: 1 },
        { x: b.left - base.left + tl.scrollLeft, width: b.width, duration: .3, ease: 'power2.inOut', onComplete: function () { tl.classList.remove('is-sliding'); gsap.set(thumb, { opacity: 0 }); } });
      if (panel) gsap.fromTo(panel, { y: 10, opacity: 0 }, { y: 0, opacity: 1, duration: .32, ease: 'power2.out', clearProps: 'transform,opacity' });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t, false); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight' || k === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
        else if (k === 'ArrowLeft' || k === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (k === 'Home') n = tabs[0];
        else if (k === 'End') n = tabs[tabs.length - 1];
        if (!n) return;
        e.preventDefault(); select(n, true);
      });
    });
    /* QA deep link: ?shoptab=adults|bundles opens on that tab */
    var want = (/[?&]shoptab=(\w+)/.exec(W.location.search) || [])[1];
    var wt = want && tabs.filter(function (t) { return t.getAttribute('data-tab') === want; })[0];
    if (wt) { quiet = true; select(wt, false); quiet = false; }
    if (W.LNMotion && W.LNMotion.onStatic) W.LNMotion.onStatic(function () { tl.classList.remove('is-sliding'); if (W.gsap && thumb) W.gsap.set(thumb, { clearProps: 'all' }); });
  }

  /* ---------- hero copy stack (>= 1024): the action block follows the headline + subhead, however the subhead wraps ---------- */
  function heroStack() {
    var hs = $('.ll-c-hero'), ha = $('.ll-c-hero-a'); if (!hs || !ha || hs.__llStack) return; hs.__llStack = 1;
    var mq = W.matchMedia('(min-width: 1024px)');
    function place() { if (mq.matches) hs.style.setProperty('--hb-top', Math.round(ha.offsetTop + ha.offsetHeight + 28) + 'px'); else hs.style.removeProperty('--hb-top'); }
    place(); W.addEventListener('resize', place);
    if (D.fonts && D.fonts.ready) D.fonts.ready.then(place);
    if (W.ResizeObserver) new ResizeObserver(place).observe(ha);
  }

  /* ---------- phone review row (why-c.js, both modes: navigation, not motion) ---------- */
  function reviewRow() {
    var list = D.getElementById('parent-review-list'); if (!list || list.__ll) return; list.__ll = 1;
    var wrap = list.closest('.ll-c-rv-rail-wrap') || list.parentNode, more = D.getElementById('moreReviews');
    var mq = W.matchMedia('(max-width: 767px)'), reduce = W.matchMedia('(prefers-reduced-motion: reduce)'), nav = null, opened = false, cur = 0;
    var L = function (k, n, tot) { return (list.getAttribute('data-' + k) || '').replace('[n]', n).replace('[total]', tot); };
    var su = $('svg use', wrap.closest('section') || D), sprite = su ? (su.getAttribute('href') || '').split('#')[0] : '';
    if (more) more.addEventListener('click', function () { opened = true; });
    function slides() { return $$('.ll-c-rv', list); }
    function step() { var s = slides(); return s.length > 1 ? s[1].offsetLeft - s[0].offsetLeft : list.clientWidth; }
    function go(i) { var n = slides().length; i = clamp(i, 0, n - 1); list.scrollTo({ left: i * step(), behavior: reduce.matches ? 'auto' : 'smooth' }); }
    function mark() {
      if (!nav) return;
      var n = slides().length, i = clamp(Math.round(list.scrollLeft / Math.max(1, step())), 0, n - 1);
      cur = i;
      $$('.ll-c-rv-dots button', nav).forEach(function (b, j) { b.setAttribute('aria-current', String(j === i)); });
      $('.ll-c-rv-count', nav).textContent = L('count', i + 1, n);
      $('.ll-c-rv-prev', nav).disabled = i === 0; $('.ll-c-rv-next', nav).disabled = i === n - 1;
      slides().forEach(function (s, j) { s.setAttribute('aria-hidden', String(j !== i)); });
    }
    function onRow() {
      if (nav) return;
      slides().forEach(function (s) { s.hidden = false; });
      wrap.classList.add('ll-c-rv-carousel');
      list.setAttribute('aria-roledescription', 'carousel'); list.setAttribute('aria-label', list.getAttribute('data-label') || '');
      var n = slides().length, dots = '';
      for (var i = 0; i < n; i++) dots += '<button type="button" aria-label="' + L('dot', i + 1, n) + '" aria-current="false" data-heatmap-id="hp-reviews-dot-' + (i + 1) + '"></button>';
      nav = D.createElement('div'); nav.className = 'll-c-rv-nav'; nav.setAttribute('role', 'group'); nav.setAttribute('aria-label', list.getAttribute('data-nav-label') || '');
      nav.innerHTML = '<button type="button" class="ll-c-rv-step ll-c-rv-prev" aria-label="' + (list.getAttribute('data-prev') || '') + '" data-heatmap-id="hp-reviews-prev"><svg aria-hidden="true"><use href="' + sprite + '#i-left"/></svg></button>'
        + '<div class="ll-c-rv-dots">' + dots + '</div><span class="ll-c-rv-count" aria-live="polite"></span>'
        + '<button type="button" class="ll-c-rv-step ll-c-rv-next" aria-label="' + (list.getAttribute('data-next') || '') + '" data-heatmap-id="hp-reviews-next"><svg aria-hidden="true"><use href="' + sprite + '#i-right"/></svg></button>';
      list.parentNode.insertBefore(nav, list.nextSibling);
      $('.ll-c-rv-prev', nav).addEventListener('click', function () { go(cur - 1); });
      $('.ll-c-rv-next', nav).addEventListener('click', function () { go(cur + 1); });
      $$('.ll-c-rv-dots button', nav).forEach(function (b, j) { b.addEventListener('click', function () { go(j); }); });
      list.scrollLeft = 0; cur = 0; mark();
    }
    function offRow() {
      if (!nav) return;
      nav.remove(); nav = null; wrap.classList.remove('ll-c-rv-carousel');
      list.removeAttribute('aria-roledescription'); list.removeAttribute('aria-label');
      slides().forEach(function (s) { s.removeAttribute('aria-hidden'); if (!opened && s.classList.contains('ll-c-rv-extra')) s.hidden = true; });
    }
    var t = 0;
    list.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(mark, 60); }, { passive: true });
    function syncRow() { if (mq.matches) onRow(); else offRow(); }
    if (mq.addEventListener) mq.addEventListener('change', syncRow); else if (mq.addListener) mq.addListener(syncRow);
    W.addEventListener('resize', function () { if (nav) mark(); });
    syncRow();
  }

  /* ---------- bundle card: the live Back-to-School sequence (sections/hero-offer.liquid + the bundle page's check) ----------
     ONE atomic /cart/add.js with the gifts listed first and the bundle on the 0% offer plan last (Shopify prepends lines,
     so the paid line lands on top; a gifts-only moment would let UpCart's gift-guard sweep them), then /discount/<code>,
     then /cart.js: the bundle line must equal the promised price, else the visitor is told before checkout. */
  function bundleOffer() {
    $$('[data-ll-offer-atc]').forEach(bindOffer);
  }
  function bindOffer(btn) {
    if (btn.__ll) return; btn.__ll = 1;
    var art = btn.closest('.ll-c-bundle') || D, form = btn.closest('form'), err = $('[data-ll-offer-error]', art);
    var prior = btn.innerHTML;
    function post(url, body) {
      return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (b) { if (!r.ok) throw new Error(b.description || b.message || 'add failed'); return b; }); });
    }
    function say(txt) { btn.textContent = txt; }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true; if (err) err.hidden = true;
      say(btn.getAttribute('data-adding') || prior);
      var vid = Number(btn.getAttribute('data-variant')), plan = Number(btn.getAttribute('data-plan')), code = btn.getAttribute('data-code');
      var gifts = (btn.getAttribute('data-gifts') || '').split(',').filter(Boolean).map(function (id) { return { id: Number(id), quantity: 1 }; });
      var paid = [{ id: vid, quantity: 1, selling_plan: plan }];
      var expected = Number(btn.getAttribute('data-expected'));
      post('/cart/add.js', { items: gifts.concat(paid) })
        .catch(function (e1) {
          if (!gifts.length) throw e1;
          /* a 422 on one $0 gift must never cost the sale: paid line first, then the gifts, non-fatally */
          return post('/cart/add.js', { items: paid }).then(function () { return post('/cart/add.js', { items: gifts }).catch(function () {}); });
        })
        .then(function () { return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin', cache: 'no-store' }).catch(function () {}); })
        .then(function () { return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          var line = 0;
          (cart.items || []).forEach(function (i) { if (i.variant_id === vid) line += i.final_line_price; });
          if (typeof W.upcartRefreshCart === 'function') W.upcartRefreshCart();
          if (line !== expected) {
            if (err) { err.textContent = (btn.getAttribute('data-error') || '').replace('[cart]', money(line)).replace('[expected]', money(expected)); err.hidden = false; }
            btn.innerHTML = prior; btn.disabled = false;
            return;
          }
          if (typeof W.upcartOpenCart === 'function') W.upcartOpenCart();
          D.dispatchEvent(new CustomEvent('cart:updated'));
          say(btn.getAttribute('data-added') || '');
          setTimeout(function () { btn.innerHTML = prior; btn.disabled = false; }, 2500);
        })
        .catch(function () { say(btn.getAttribute('data-retry') || ''); btn.disabled = false; setTimeout(function () { btn.innerHTML = prior; }, 3000); });
    });
  }

  /* ---------- floating fruit: keep every fruit (with its float) 24 px clear of text and controls, both modes ---------- */
  var fruitItems = [], fruitLayers = [];
  function fruitGuard() {
    fruitLayers = $$('.ll-c-fruit');
    if (!fruitLayers.length) return;
    var CLEAR = { hero: '.ll-c-lockup, .ll-c-hero-sub, .ll-c-btn-hero, .ll-c-hero-rating, .ll-c-chips li, .ll-c-hero-proof, .ll-c-hero-honor, .ll-c-jar-ernest', sunset: '.ll-c-summit-head' };
    fruitItems = [];
    fruitLayers.forEach(function (L) {
      L.__k = (L.className.match(/ll-c-fruit-(\w+)/) || [])[1];
      L.__sec = L.closest('section') || D.body;
      $$('.ll-c-fr', L).forEach(function (f) {
        var d = +f.getAttribute('data-d') || .5, ph = +f.getAttribute('data-ph') || 0;
        fruitItems.push({ el: f, L: L, d: d, ph: ph, T: 7 + 6 * ((ph * 3.7 + d) % 1), R: 2.5 + 3.5 * d, A: 8 });
      });
    });
    function amp(w) { return Math.max(6, Math.min(14, w * .09)); }
    function guard() {
      var sy = W.scrollY || 0;
      fruitLayers.forEach(function (L) {
        var obs = [], sel = (CLEAR[L.__k] || 'x-none') + (L.__k === 'hero' && W.innerWidth < 768 ? ', #heroJar' : '');
        $$(sel, L.__sec).forEach(function (e) { var r = e.getBoundingClientRect(); if (r.width && r.height) obs.push([r.left, r.top + sy, r.right, r.bottom + sy]); });
        fruitItems.forEach(function (it) {
          if (it.L !== L) return;
          it.el.classList.remove('ll-c-fr-off');
          var u = $('use', it.el); if (!u || !it.el.offsetWidth) return;
          var t = it.el.style.transform; it.el.style.transform = '';
          var r = u.getBoundingClientRect(); it.el.style.transform = t;
          it.A = amp(it.el.offsetWidth);
          var px = 24 + it.el.offsetWidth * .06, py = px + it.A;
          if (obs.some(function (o) { return r.left - px < o[2] && r.right + px > o[0] && r.top + sy - py < o[3] && r.bottom + sy + py > o[1]; })) it.el.classList.add('ll-c-fr-off');
        });
      });
    }
    guard();
    if (D.fonts && D.fonts.ready) D.fonts.ready.then(guard);
    var gT = 0; W.addEventListener('resize', function () { clearTimeout(gT); gT = setTimeout(guard, 160); });
  }

  /* =============================================================== 2. motion */
  function motion(LN) {
    var gsap = W.gsap, ST = W.ScrollTrigger;
    if (!gsap || !ST) return;
    var hero = $('#top');

    if (LN.eases && LN.EASES) LN.eases(LN.EASES);   /* the kit's material eases (settle, paper, squish, lid ...) */
    if (LN.eases) LN.eases({ rise: 'M0,0 C0.18,0.72 0.32,1.06 0.56,1.03 0.76,1 0.88,1 1,1', dawn: 'M0,0 C0.38,0 0.24,1 1,1' });

    /* ---------- the sunset (pure function of p; the still is baked into the markup at p .28) ---------- */
    var SS = { sun: $('.ll-c-ss-sun'), dusk: $('.ll-c-ss-dusk'), wrap: $('#summitSky'), farD: $('.ll-c-ss-far-dusk'), peachD: $('.ll-c-ss-peach-dusk'), midD: $('.ll-c-ss-mid-dusk'), stars: $$('.ll-c-ss-st'), llama: $('#summitLlama svg') };
    function renderSunset(p) {
      var k = seg(p, .1, .9);
      if (SS.sun) SS.sun.setAttribute('transform', 'translate(0 ' + ((k - .5) * 210).toFixed(1) + ')');
      if (SS.dusk) SS.dusk.style.opacity = seg(p, .4, .95).toFixed(3);
      if (SS.wrap) SS.wrap.style.setProperty('--dusk', seg(p, .4, .95).toFixed(3));
      if (SS.farD) SS.farD.style.opacity = seg(p, .45, .75).toFixed(3);
      if (SS.peachD) SS.peachD.style.opacity = seg(p, .5, .8).toFixed(3);
      if (SS.midD) SS.midD.style.opacity = seg(p, .55, .85).toFixed(3);
      SS.stars.forEach(function (s, j) { s.style.opacity = seg(p, .8 + j * .025, .9 + j * .025).toFixed(3); });
      if (SS.llama) SS.llama.style.transform = p > .6 ? 'scaleX(-1)' : '';
    }
    function stillSunset() {
      renderSunset(.28);
      [SS.dusk, SS.farD, SS.peachD, SS.midD].concat(SS.stars).forEach(function (e) { if (e) e.style.opacity = ''; });
      if (SS.wrap) SS.wrap.style.removeProperty('--dusk');
      if (SS.llama) SS.llama.style.transform = '';
    }

    /* ---------- hero intro (the jar keeps opacity 1 throughout: it is the LCP image) ---------- */
    var jar = $('#heroJar'), sun = $('#heroSun');
    var planes = { sky: $('.ll-c-pl-sky'), cloud: $('.ll-c-pl-cloud'), far: $('.ll-c-pl-far'), peach: $('.ll-c-pl-peach'), mid: $('.ll-c-pl-mid'), near: $('.ll-c-pl-near') };
    var inner = function (el) { return el ? $('.ll-c-w-svg', el) : null; };
    var heroActive = true, idleOn = false, idle = null;
    if (hero && jar) {
      var hills = [inner(planes.far), inner(planes.peach), inner(planes.mid), inner(planes.near)].filter(Boolean);
      gsap.set($('.ll-c-dawn'), { opacity: 1 });
      if (sun) gsap.set(sun, { yPercent: 62 });
      gsap.set($('.ll-c-sun-rays'), { rotation: -20, opacity: 0 });
      gsap.set(hills, { y: function (i) { return [18, 26, 34, 40][i]; } });
      if (inner(planes.cloud)) gsap.set(inner(planes.cloud), { x: -36, opacity: 0 });
      gsap.set(jar, { yPercent: 8 });
      gsap.set($('.ll-c-jar-shadow'), { scaleX: .6 });
      gsap.set($$('.ll-c-lockup .ll-c-lk'), { y: 14 });
      gsap.set($$('.ll-c-hero .ll-c-rl'), { x: -40, opacity: 0 });
      gsap.set($$('.ll-c-chips svg'), { scale: .6 });
      if (LN.releasePre) LN.releasePre();
      gsap.timeline({ defaults: { overwrite: 'auto' } })
        .to($('.ll-c-dawn'), { opacity: 0, duration: .9, ease: 'dawn' }, 0)
        .to(sun, { yPercent: 0, duration: 1.0, ease: 'dawn' }, 0)
        .fromTo($('.ll-c-sun-disc'), { scaleY: .94 }, { keyframes: [{ scaleY: 1.02, duration: .09 }, { scaleY: 1, duration: .09 }], ease: 'squish' }, .9)
        .to($('.ll-c-sun-rays'), { rotation: 0, opacity: .7, duration: .7, ease: 'power2.out' }, .85)
        .to(hills, { y: 0, duration: .7, ease: 'paper', stagger: .08 }, .15)
        .to(inner(planes.cloud), { x: 0, opacity: 1, duration: 1.2, ease: 'paper' }, .3)
        .to(jar, { y: 6, duration: .06, ease: 'power1.in' }, .2)
        .to(jar, { yPercent: 0, y: 0, duration: .45, ease: 'rise' }, .26)
        .to(jar, { scaleY: 1.03, duration: .3, ease: 'power1.out' }, .26)
        .to(jar, { keyframes: [{ scaleY: .985, duration: .1 }, { scaleY: 1, duration: .16 }], ease: 'sine.inOut' }, .61)
        .to($('.ll-c-jar-shadow'), { scaleX: 1, duration: .45, ease: 'rise' }, .26)
        .to($$('.ll-c-lockup .ll-c-lk'), { y: 0, duration: .55, ease: 'rise', stagger: .09 }, .5)
        .to($$('.ll-c-hero .ll-c-rl'), { x: 0, opacity: 1, duration: .9, ease: 'none', stagger: .15 }, 1.1)
        .to($$('.ll-c-chips svg'), { scale: 1, duration: .4, ease: 'back.out(2)', stagger: .08 }, 1.2)
        .add(function () { idleOn = true; if (idle) idle.wake(); }, 2.2);

      /* scroll parallax (pure function of h) + fine-pointer parallax, smoothed */
      var PAR = [[planes.sky, .48, 0], [sun, .40, 10], [planes.cloud, .38, 10], [planes.far, .30, 14], [planes.peach, .24, 18],
        [planes.mid, .18, 22], [planes.near, 0, 38], [$('#jarStage'), 0, 38], [$('.ll-c-rl-a'), 0, 38], [$('.ll-c-rl-b'), 0, 38], [$('.ll-c-grain-hero'), .48, 0]].filter(function (a) { return a[0]; });
      var setters = PAR.map(function (a) { return { x: gsap.quickSetter(a[0], 'x', 'px'), y: gsap.quickSetter(a[0], 'y', 'px'), f: a[1], A: a[2], el: a[0] }; });
      var HP = { h: 0, px: 0, py: 0, tx: 0, ty: 0, last: '' };
      var renderHero = function () {
        var hh = hero.offsetHeight, key = HP.h.toFixed(4) + HP.px.toFixed(3) + HP.py.toFixed(3);
        if (key === HP.last) return; HP.last = key;
        setters.forEach(function (s) { var y = HP.h * hh * s.f + .4 * s.A * HP.py, x = s.A * HP.px; if (s.el === sun) y -= 24 * HP.h; s.x(x); s.y(y); });
      };
      var cloudG = $$('.ll-c-pl-cloud .ll-c-cl'), rls = $$('.ll-c-hero .ll-c-rl svg');
      idle = LN.loop(function (dt, t) {
        if (!heroActive) return false;
        var k = 1 - Math.exp(-dt / .18);
        HP.px += (HP.tx - HP.px) * k; HP.py += (HP.ty - HP.py) * k;
        if (idleOn) {
          var s = t / 1000;
          cloudG.forEach(function (c, i) { c.style.translate = (Math.sin(s * .35 + i * 1.7) * 12).toFixed(2) + 'px 0'; });
          rls.forEach(function (r, i) { r.style.translate = '0 ' + (Math.max(0, Math.sin(s * 2.6 + i * 2)) * 2).toFixed(2) + 'px'; });
        }
        renderHero();
        return idleOn || Math.abs(HP.tx - HP.px) > .001 || Math.abs(HP.ty - HP.py) > .001;
      });
      ST.create({ trigger: hero, start: 'top top', end: 'bottom top', onUpdate: function (s) { HP.h = s.progress; renderHero(); }, onToggle: function (s) { heroActive = s.isActive; if (heroActive) idle.wake(); } });
      if (LN.finePointer) {
        hero.addEventListener('pointermove', function (e) { var r = hero.getBoundingClientRect(); HP.tx = (e.clientX - r.left) / r.width - .5; HP.ty = (e.clientY - r.top) / r.height - .5; idle.wake(); });
        hero.addEventListener('pointerleave', function () { HP.tx = 0; HP.ty = 0; idle.wake(); });
      }
      var raysTarget = $('.ll-c-sun-rays g') || $('.ll-c-sun-rays');
      var raysSpin = gsap.to(raysTarget, { rotation: 360, duration: 60, repeat: -1, ease: 'none', transformOrigin: '50% 50%', paused: true });
      ST.create({ trigger: hero, start: 'top top', end: 'bottom top', onToggle: function (s) { s.isActive ? raysSpin.resume() : raysSpin.pause(); } });
      gsap.delayedCall(2.4, function () { raysSpin.play(); });
      W.addEventListener('resize', function () { HP.last = ''; renderHero(); });
      if (sun) sun.addEventListener('click', function () { gsap.to($('.ll-c-sun-rays'), { rotation: '+=90', duration: .6, ease: 'back.out(1.4)' }); gsap.fromTo($('.ll-c-sun-glow'), { opacity: .6, scale: .9 }, { opacity: 0, scale: 1.25, duration: .5, ease: 'power1.out' }); });
      $$('.ll-c-hero .ll-c-rl').forEach(function (r) { r.addEventListener('click', function () { gsap.fromTo($('svg', r), { y: 0 }, { y: -14, duration: .13, yoyo: true, repeat: 1, ease: 'power2.out' }); }); });
    }

    /* ---------- blinks, bubbles, taps (decorative; carry no information) ---------- */
    function visible(el) { var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < W.innerHeight && r.width > 0; }
    function blink(wrap) { var b = $('.ll-c-cast-blink', wrap); if (!b) return; gsap.to(b, { opacity: 1, duration: .05, onComplete: function () { gsap.to(b, { opacity: 0, duration: .06, delay: .095 }); } }); }
    function bubble(el, ms) { if (!el) return; el.classList.add('ll-c-is-on'); gsap.fromTo(el, { scale: .8, y: 6 }, { scale: 1, y: 0, duration: .3, ease: 'back.out(2.2)', transformOrigin: '20% 100%' }); clearTimeout(el.__t); el.__t = setTimeout(function () { el.classList.remove('ll-c-is-on'); }, ms || 2600); }
    function hop(el, h) { gsap.fromTo(el, { y: 0 }, { y: -(h || 6), duration: .16, yoyo: true, repeat: 1, ease: 'power2.out', overwrite: false }); }
    var ag = $('#assistGinger');
    if (ag) {
      (function loop() { setTimeout(function () { if (!D.hidden && LN.motion && visible(ag)) blink(ag); if (LN.motion) loop(); }, 3200 + Math.random() * 2300); })();
      ag.style.pointerEvents = 'auto';
      ag.addEventListener('click', function () { blink(ag); hop(ag, 6); bubble($('#faqBubble')); });
    }
    var seal = $('#honorSeal'), sealWrap = $('.ll-c-seal-wrap');
    if (sealWrap && seal) sealWrap.addEventListener('click', function () { gsap.fromTo(seal, { rotation: 0 }, { keyframes: [{ rotation: -7, duration: .12 }, { rotation: 5, duration: .14 }, { rotation: -2, duration: .14 }, { rotation: 0, duration: .2 }], ease: 'sine.inOut', transformOrigin: '50% 10%' }); });

    /* ---------- entrances: one verb, "rise", played once ---------- */
    function onceIn(targets, vars, trigger, start) {
      targets = [].concat(targets).filter(Boolean); if (!targets.length) return;
      var tw = gsap.from(targets, Object.assign({ paused: true, immediateRender: true }, vars));
      ST.create({ trigger: trigger || targets[0], start: start || 'top 92%', once: true, onEnter: function () { tw.play(); } });
    }
    $$('.ll-c h2').forEach(function (h) { if (h.closest('.ll-c-hero') || h.closest('dialog')) return; onceIn(h, { y: 24, duration: .6, ease: 'rise' }, h, 'top bottom'); });
    onceIn($$('.ll-c-stats li'), { y: 24, duration: .6, ease: 'rise', stagger: .06 }, '.ll-c-stats');
    onceIn($('.ll-c-founders-pic'), { y: 18, rotation: '+=4', duration: .52, ease: 'paper' }, '.ll-c-founders');
    onceIn($('.ll-c-bundle'), { y: 20, duration: .6, ease: 'rise' }, '.ll-c-bundle');
    onceIn($$('#kids-product-grid .ll-c-product'), { y: 20, duration: .6, ease: 'rise', stagger: .07 }, '#kids-product-grid');
    onceIn($$('#kids-product-grid .ll-c-p-jar'), { yPercent: 18, duration: .52, ease: 'settle', stagger: .07, delay: .12 }, '#kids-product-grid');
    onceIn($$('.ll-c-reviews .ll-c-postcard:not([hidden])'), { y: -16, rotation: '+=2', duration: .5, ease: 'paper', stagger: .08 }, '.ll-c-rv-videos');
    onceIn($$('.ll-c-expert'), { y: 24, duration: .6, ease: 'rise', stagger: .09 }, '.ll-c-expert-grid');
    onceIn($$('.ll-c-q-ico'), { scale: 1.2, rotation: -8, duration: .28, ease: 'squish', stagger: .06 }, '.ll-c-quality-grid');
    onceIn($$('.ll-c-plaque'), { y: 20, duration: .6, ease: 'rise', stagger: .07 }, '.ll-c-quality-grid');
    onceIn($$('.ll-c-qa'), { x: -16, duration: .5, ease: 'paper', stagger: .05 }, '.ll-c-faq-list');
    onceIn($$('.ll-c-sp'), { y: 18, duration: .5, ease: 'paper', stagger: .05 }, '.ll-c-summit-photos', 'top 98%');
    onceIn($('.ll-c-assist-ginger'), { yPercent: 70, duration: .52, ease: 'back.out(1.7)' }, '.ll-c-assist');
    onceIn(seal, { y: -40, rotation: -8, duration: .64, ease: 'settle' }, '.ll-c-honor');
    onceIn($('#honorRays'), { rotation: -30, opacity: 0, duration: .9, ease: 'power2.out' }, '.ll-c-honor');
    onceIn($('.ll-c-honor-rock'), { y: 14, scaleX: .9, duration: .5, ease: 'squish' }, '.ll-c-honor');
    var raysLoop = $('#honorRays .ll-c-rays-g') ? gsap.to('#honorRays .ll-c-rays-g', { rotation: 360, duration: 90, repeat: -1, ease: 'none', svgOrigin: '0 0', paused: true }) : null;
    var raysBigLoop = $('#honorRaysBig .ll-c-rays-g') ? gsap.to('#honorRaysBig .ll-c-rays-g', { rotation: -360, duration: 160, repeat: -1, ease: 'none', svgOrigin: '0 0', paused: true }) : null;
    if ($('.ll-c-honor')) ST.create({ trigger: '.ll-c-honor', start: 'top bottom', end: 'bottom top', onToggle: function (s) { [raysLoop, raysBigLoop].forEach(function (l) { if (l) s.isActive ? l.resume() : l.pause(); }); } });
    $$('.ll-c-qa').forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) gsap.from($('.ll-c-answer', d), { y: 8, opacity: 0, duration: .2, ease: 'power1.out' }); }); });

    /* ---------- bands: front ridge drift, trail march, the silhouette walker ---------- */
    $$('.ll-c-band').forEach(function (b) {
      var front = $('.ll-c-bd-front', b), trail = $('.ll-c-bd-trail', b), walker = $('.ll-c-walker', b);
      if (front) gsap.fromTo(front, { y: 0 }, { y: 7, ease: 'none', scrollTrigger: { trigger: b, start: 'top bottom', end: 'bottom top', scrub: true } });
      if (trail) gsap.fromTo(trail, { strokeDashoffset: 36 }, { strokeDashoffset: 0, duration: 1.4, ease: 'power1.out', scrollTrigger: { trigger: b, start: 'top 90%', once: true } });
      if (walker && trail && W.MotionPathPlugin) {
        var wt = gsap.timeline({ paused: true });
        wt.set(walker, { opacity: 1 })
          .to(walker, { duration: 2.4, ease: 'none', motionPath: { path: trail, align: trail, alignOrigin: [.5, .96], start: .14, end: .7 } })
          .fromTo($('use', walker) || walker, { y: 0 }, { y: -1.5, duration: .083, repeat: 28, yoyo: true, ease: 'sine.inOut' }, 0);
        ST.create({ trigger: b, start: 'top 82%', once: true, onEnter: function () { wt.play(); } });
      }
    });

    /* ---------- videos: previews start when the rail is near (the Pause chip stops them) ---------- */
    var rail = $('.ll-c-rv-videos');
    if (rail && LN.near && W.LLHome.setPreviews) LN.near(rail, function () { W.LLHome.setPreviews(true); });

    /* ---------- the sunset scrub ---------- */
    if ($('#summitSky')) {
      ST.create({ trigger: '#summitSky', start: 'top bottom', end: function () { return 'top ' + hdrH() + 'px'; }, onUpdate: function (s) { renderSunset(s.progress); }, onRefresh: function (s) { renderSunset(s.progress); } });
    }

    jarTour(LN);
    fruitMotion(LN);

    LN.onStatic(function () {
      stillSunset();
      [jar, sun].concat($$('.ll-c-lockup .ll-c-lk'), $$('.ll-c-chips svg'), $$('.ll-c-hero .ll-c-rl')).forEach(function (e) { if (e) gsap.set(e, { clearProps: 'all' }); });
    });
    if (LN.refresh) LN.refresh(300);
  }

  /* ---------- the ingredients tour (why-c.js): pinned stage, every frame a pure function of the pin's progress ---------- */
  function jarTour(LN) {
    var gsap = W.gsap, ST = W.ScrollTrigger;
    var stage = $('#jcStage'); if (!stage) return;
    var f = function (v) { return v.toFixed(1); };
    var field = $('#jcField');
    var foods = $$('.ll-c-jc-food', field), phs = foods.map(function (li) { return $('.ll-c-jc-ph', li); }), ftags = foods.map(function (li) { return $('.ll-c-jc-tag', li); });
    var jar = $('#jcJar'), jarOpen = $('.ll-c-jc-jar-open', jar), lid = $('.ll-c-jc-jar-lid', jar);
    var gin = $('#jcGinger'), gClip = $('.ll-c-jc-g-clip', gin), gBlink = $('.ll-c-g-blink', gin), gPl = $('.ll-c-jc-g-pleased', gin), say = $('#jcSay');
    var steps = $('#jcSteps'), stepEls = steps ? $$('.ll-c-jc-step', steps) : [];
    var ben = $('#jcBen'), benH = ben ? $('.ll-c-jc-ben-h', ben) : null, benI = ben ? $$('.ll-c-jb', ben) : [];
    if (!jar || !jarOpen || !lid || !gin) return;
    function box(el) { var x = 0, y = 0, e = el; while (e && e !== field) { x += e.offsetLeft; y += e.offsetTop; e = e.offsetParent; } return { x: x, y: y, w: el.offsetWidth, h: el.offsetHeight }; }
    var SPREAD = [-.12, .08, -.2, .16, -.04, .2, -.16, .04], arcs = [], act = [], meet = { j: 0, g: 0 };
    var FL = { s0: .04, step: .092, dur: .15, last: .834 };
    function layout() {
      var J = box(jar); if (!J.w) return false;
      var row = W.innerWidth >= 1280;
      if (row && !ben) { var G = box(gin), gap = Math.max(16, field.offsetWidth * .03), left = (field.offsetWidth - (J.w + gap + G.w)) / 2; meet = { j: left - J.x, g: left + J.w + gap - G.x }; } else meet = { j: 0, g: 0 };
      act = foods.map(function (li, i) { return li.offsetParent ? i : -1; }).filter(function (i) { return i >= 0; });
      FL.step = act.length > 1 ? (FL.last - FL.dur - FL.s0) / (act.length - 1) : 0;
      arcs = act.map(function (i, k) {
        var b = box(phs[i]), ps = b.w, p0 = { x: b.x + b.w / 2, y: b.y + b.h / 2 };
        var p3 = { x: J.x + J.w * (.5 + SPREAD[k % SPREAD.length]), y: J.y + J.h * .31 };
        var lift = ps * (row ? .45 : .15), top = Math.min(p0.y, p3.y) - lift, d = p0.x - p3.x;
        return { p0: p0, p1: { x: p0.x - d * (row ? .3 : .6), y: top }, p2: { x: p3.x, y: top }, p3: p3 };
      });
      return true;
    }
    function bez(a, t) { var u = 1 - t, A = u * u * u, B = 3 * u * u * t, C = 3 * u * t * t, E = t * t * t; return { x: A * a.p0.x + B * a.p1.x + C * a.p2.x + E * a.p3.x, y: A * a.p0.y + B * a.p1.y + C * a.p2.y + E * a.p3.y }; }
    var land = function (k) { return FL.s0 + k * FL.step + FL.dur; };
    var io = function (x) { return x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; };
    var out2 = function (x) { return 1 - (1 - x) * (1 - x); };
    var S = { p: 0, target: 0, last: -1, step: 0 }, R;
    R = function (force) {
      if (!arcs.length) return;
      var p = S.p; if (!force && Math.abs(p - S.last) < 1e-5) return; S.last = p;
      var sq = 0, nod = 0;
      arcs.forEach(function (a, k) {
        var i = act[k], t0 = FL.s0 + k * FL.step, u = seg(p, t0, t0 + FL.dur), ph = phs[i], li = foods[i];
        if (u <= 0) { ph.style.transform = ''; ph.style.opacity = ''; li.style.zIndex = ''; }
        else {
          var ue = io(u), pt = bez(a, ue), sc = 1 - .6 * ue;
          ph.style.transform = 'translate(' + f(pt.x - a.p0.x) + 'px,' + f(pt.y - a.p0.y) + 'px) scale(' + sc.toFixed(3) + ')';
          ph.style.opacity = u >= 1 ? 0 : (1 - seg(u, .88, 1)).toFixed(3);
          li.style.zIndex = u < 1 ? 3 : '';
        }
        ftags[i].classList.toggle('ll-c-is-gone', u > .02);
        var kk = seg(p, land(k), land(k) + .02); if (kk > 0 && kk < 1) sq = Math.max(sq, .03 * Math.exp(-6 * kk) * Math.abs(Math.cos(10 * kk)));
        var nk = seg(p, land(k), land(k) + .025); if (nk > 0 && nk < 1) nod = Math.max(nod, Math.sin(Math.PI * nk));
      });
      var lk = seg(p, .86, .92), lb = seg(p, .92, .95);
      lid.style.opacity = seg(p, .86, .87).toFixed(3);
      lid.style.transform = 'translateY(' + (-14 * (1 - out2(lk)) - 2.2 * Math.sin(Math.PI * lb)).toFixed(2) + '%) rotate(' + (-10 * (1 - lk)).toFixed(2) + 'deg)';
      if (lb > 0 && lb < 1) sq = Math.max(sq, .025 * Math.sin(Math.PI * lb));
      jarOpen.style.transform = sq ? 'scaleY(' + (1 - sq).toFixed(4) + ') scaleX(' + (1 + sq * .6).toFixed(4) + ')' : '';
      var mg = io(seg(p, .84, .95));
      jar.style.transform = meet.j ? 'translateX(' + f(meet.j * mg) + 'px)' : '';
      var tt = seg(p, .84, .875), hp = seg(p, .93, .99), u0 = gin.offsetHeight / 300, turned = p >= .8575;
      var rot = -2.2 * nod * (1 - tt), sx = 1 - .1 * Math.sin(Math.PI * tt), gy = -10 * u0 * Math.sin(Math.PI * hp);
      gin.style.transform = 'translate(' + f(meet.g * mg) + 'px,' + f(gy) + 'px) rotate(' + rot.toFixed(2) + 'deg) scaleX(' + sx.toFixed(3) + ')';
      gClip.style.opacity = turned ? 0 : 1; gPl.style.opacity = turned ? 1 : 0;
      var bp = seg(p, .88, .92), bo = bp < 1 ? 1 + 2.2 * Math.pow(bp - 1, 3) + 1.2 * Math.pow(bp - 1, 2) : 1;
      if (say) { say.style.opacity = bp.toFixed(3); say.style.transform = 'translateX(' + f(meet.g * mg) + 'px) scale(' + (.55 + .45 * bo).toFixed(3) + ')'; }
      /* the benefits rise out of the closed jar into the space the foods left: the line first, then each benefit in turn */
      if (benH) { var bh = seg(p, .80, .87); benH.style.opacity = bh.toFixed(3); benH.style.transform = 'translateY(' + f(14 * (1 - out2(bh))) + 'px)'; }
      benI.forEach(function (el, k) { var u = seg(p, .84 + k * .035, .90 + k * .035), e = out2(u); el.style.opacity = u.toFixed(3); el.style.transform = 'translateY(' + f(46 * (1 - e)) + 'px) scale(' + (.7 + .3 * e).toFixed(3) + ')'; });
      var stp = p < FL.s0 + 2 * FL.step ? 1 : p < .84 ? 2 : 3;
      if (steps && stp !== S.step) { S.step = stp; steps.setAttribute('data-on', stp); stepEls.forEach(function (li) { li.classList.toggle('ll-c-is-on', +li.getAttribute('data-step') === stp); }); }
    };
    var PHONE_PIN = .25;
    var head = $('.ll-c-jc-head', stage), after = $('#jcAfter');
    var measure = function () { if (head) stage.style.setProperty('--jc-hd', (field.offsetTop - head.offsetTop) + 'px'); if (after) stage.style.setProperty('--jc-af', after.offsetHeight + 'px'); };
    measure();
    ST.addEventListener('refreshInit', measure);
    var smooth = LN.loop(function (dt) {
      if (!R) return false;
      var d = S.target - S.p;
      if (Math.abs(d) < 1e-4) { S.p = S.target; R(); return false; }
      S.p += d * (1 - Math.exp(-dt / (W.innerWidth < 768 ? .14 : .085)));
      R();
    });
    var st = ST.create({
      trigger: stage,
      start: function () {
        var hh = hdrH(), room = W.innerHeight - hh, h = stage.offsetHeight;
        if (h <= room + 1) return 'top ' + hh + 'px';
        if (W.innerWidth < 1280) { var skip = field.offsetTop - 10; if (h - skip <= room + 1) return 'top ' + (hh - skip) + 'px'; }
        return 'bottom bottom';
      },
      end: function () { return '+=' + Math.round(W.innerHeight * (W.innerWidth >= 1024 ? 1.3 : W.innerWidth >= 768 ? 1 : PHONE_PIN)); },
      pin: true, pinSpacing: true, refreshPriority: 1, invalidateOnRefresh: true,
      onUpdate: function (s) { S.target = s.progress; smooth.wake(); },
      onToggle: function (s) { D.documentElement.classList.toggle('jc-pinned', s.isActive); },
      onRefresh: function (s) { layout(); S.p = S.target = s.progress; if (R) R(true); }
    });
    layout(); S.p = S.target = st.progress; R(true);
    var reLay = function () { if (R && layout()) R(true); };
    W.addEventListener('resize', reLay);
    if (W.ResizeObserver) new ResizeObserver(reLay).observe(field);
    if (D.fonts && D.fonts.ready) D.fonts.ready.then(function () { measure(); ST.refresh(); });
    var rngB = LN.rng ? LN.rng(11) : Math.random, nextB = 2.2, tB = 0, onScreen = false;
    var blinkL = LN.loop(function (dt) {
      if (!onScreen) { gBlink.style.opacity = 0; return false; }
      tB += dt;
      gBlink.style.opacity = tB > nextB && tB < nextB + .14 && S.p < .85 ? 1 : 0;
      if (tB >= nextB + .14) { tB = 0; nextB = 2.6 + 2 * rngB(); }
    });
    ST.create({ trigger: stage, start: 'top bottom', end: 'bottom top', onToggle: function (s) { onScreen = s.isActive; if (onScreen) blinkL.wake(); } });
    LN.onStatic(function () {
      R = null;
      D.documentElement.classList.remove('jc-pinned');
      stage.style.removeProperty('--jc-hd'); stage.style.removeProperty('--jc-af');
      ftags.forEach(function (t) { t.classList.remove('ll-c-is-gone'); });
      phs.concat(ftags, foods, benI, [gin, gClip, gPl, gBlink, lid, jarOpen, jar, say, benH]).forEach(function (el) {
        if (el) { el.style.removeProperty('transform'); el.style.removeProperty('opacity'); el.style.removeProperty('visibility'); el.style.removeProperty('z-index'); }
      });
    });
  }

  /* ---------- floating fruit motion: slow bob + turn and a slight parallax, transforms only, asleep offscreen ---------- */
  function fruitMotion(LN) {
    var gsap = W.gsap, ST = W.ScrollTrigger, PI2 = Math.PI * 2;
    if (!fruitItems.length) return;
    var hero = $('#top'), heroL = $('.ll-c-fruit-hero');
    function render(t) {
      var s = t / 1000, sy = W.scrollY || 0, vh = W.innerHeight, hh = hero ? hero.offsetHeight : 1, any = false;
      fruitItems.forEach(function (it) {
        if (!it.L.__on) return; any = true;
        var w = PI2 * (s / it.T + it.ph), par;
        if (it.L.__k === 'hero') par = clamp(sy / hh) * hh * (.46 - .16 * it.d);
        else par = ((it.L.__p || 0) - .5) * vh * (.04 + .1 * it.d);
        it.el.style.transform = 'translate(0,' + (Math.sin(w) * it.A + par).toFixed(2) + 'px) rotate(' + (Math.sin(w * .7 + it.ph * 5) * it.R).toFixed(2) + 'deg)';
      });
      return any;
    }
    var floatLoop = LN.loop(function (dt, t) { return render(t); });
    fruitLayers.forEach(function (L) {
      var st = ST.create({ trigger: L.__k === 'hero' ? hero : L.__sec, start: 'top bottom', end: 'bottom top',
        onUpdate: function (s) { L.__p = s.progress; }, onToggle: function (s) { L.__on = s.isActive; if (s.isActive) floatLoop.wake(); },
        onRefresh: function (s) { L.__p = s.progress; L.__on = s.isActive; if (s.isActive) floatLoop.wake(); } });
      L.__p = st.progress; L.__on = st.isActive;
    });
    if (heroL) gsap.fromTo(heroL, { opacity: 0 }, { opacity: 1, duration: 1.1, delay: .3, ease: 'power1.out' });
    LN.onStatic(function () { floatLoop.sleep(); fruitItems.forEach(function (it) { it.el.style.transform = ''; }); fruitLayers.forEach(function (L) { L.style.opacity = ''; }); });
    floatLoop.wake();
  }

  /* =============================================================== boot */
  var booted = false;
  function start() {
    if (booted) return; booted = true;
    common();
    if (W.LNMotion && typeof W.LNMotion.ready === 'function') {
      W.LNMotion.ready(function (LN) { if (!LN.motion) return; try { motion(LN); } catch (e) { if (W.console) console.error('[ll-home] motion failed, staying on the still page', e); } });
    }
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start); else start();
  /* theme editor: a re-rendered section gets its common UI again (motion settles on the next page load) */
  D.addEventListener('shopify:section:load', function () { common(); });
})();
